import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=4654ecbd&scoped=true&"
import script from "./detailInfo.vue?vue&type=script&lang=ts&"
export * from "./detailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=4654ecbd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654ecbd",
  null
  
)

export default component.exports